import Box from "@material-ui/core/esm/Box";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValueLoadable, useRecoilState, useSetRecoilState } from 'recoil';
import { showCheckboxColumn, passingsToExport } from 'api/passings/getFilteredPassings';
import { getPassingsForObe, passingsPagination } from 'api/passings/getPassingsForObe';
import { PrimaryButton } from 'components/Button';
import DividerComponent from 'components/Divider/Divider';
import Pagination from 'components/Pagination/Pagination';
import PassingList from 'components/PassingsList/PassingList';
import PeriodFilter from 'components/PeriodFilter/PeriodFilter';
import Spinner from 'components/Spinner/Spinner';
import { Header, Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import ArchivedPassingsDownload from 'modules/Passings/ArchivedPassingsDownload';
import checkLoadable from 'utils/recoil/checkLoadable';
import TagPassingsDownload from './TagPassingsDownload';
import useStyles from './TagPassingStyles';
export default function TagPassings({
  tagNumber
}) {
  const {
    t
  } = useTranslation();
  const {
    exportCustomButton
  } = useStyles();
  const {
    hasArchivedPassings
  } = useCurrentCustomer();
  const obePassings = useRecoilValueLoadable(getPassingsForObe(tagNumber));
  const [pagination, setPagination] = useRecoilState(passingsPagination);
  const [showCheckbox, setShowCheckbox] = useRecoilState(showCheckboxColumn);
  const setPassingsToExport = useSetRecoilState(passingsToExport);
  const {
    contents,
    loading
  } = checkLoadable(obePassings);
  const handlePeriodFilterChange = ({
    startDate,
    endDate
  }) => {
    setPagination(currentValue => ({
      ...currentValue,
      dateFrom: startDate?.toDate(),
      dateTo: endDate?.toDate()
    }));
  };
  const handleSpecificExportButtonOnClick = () => {
    if (showCheckbox) {
      setPassingsToExport([]);
    }
    setShowCheckbox(!showCheckbox);
  };
  useEffect(() => {
    setPassingsToExport([]);
    setShowCheckbox(false);
  }, []);
  let content;
  if (loading) content = /*#__PURE__*/React.createElement(Spinner, null);else if (!loading && !contents?.totalResults) content = /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('error.no_tag_passings'));else content = /*#__PURE__*/React.createElement(PassingList, {
    items: contents?.results ?? []
  });
  return /*#__PURE__*/React.createElement(Box, {
    my: 3
  }, /*#__PURE__*/React.createElement(Header, null, t('passings.passings')), hasArchivedPassings && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArchivedPassingsDownload, {
    obeNumber: tagNumber,
    disabled: false
  }), /*#__PURE__*/React.createElement(DividerComponent, null)), /*#__PURE__*/React.createElement(PeriodFilter, {
    onChange: handlePeriodFilterChange,
    useUtc: true
  }), /*#__PURE__*/React.createElement("div", {
    className: exportCustomButton
  }, /*#__PURE__*/React.createElement(PrimaryButton, {
    onClick: () => handleSpecificExportButtonOnClick()
  }, t('passings.export_specific_passings'))), /*#__PURE__*/React.createElement(TagPassingsDownload, {
    disabled: loading || !contents?.totalResults,
    dates: {
      dateFrom: pagination.dateFrom,
      dateTo: pagination.dateTo
    },
    max: contents?.totalResults ?? pagination.max,
    obeNumber: tagNumber,
    accountId: contents?.results?.[0]?.accountId,
    showCheckbox: true
  }), content, /*#__PURE__*/React.createElement(Pagination, {
    totalResults: contents?.totalResults ?? 0,
    handlePagination: setPagination,
    paginationParams: pagination,
    rowsPerPageOptions: [5, 10, 30, 100]
  }));
}